import { defineMessages } from 'react-intl';

export default defineMessages({
  subscribe: {
    id: 'actions.subscribe',
    defaultMessage: 'Subscribe {price}/month',
  },
  buy: {
    id: 'actions.buy',
    defaultMessage: 'Buy {price}',
  },
  rent: {
    id: 'actions.rent',
    defaultMessage: 'Rent {price}',
  },
  buyFrom: {
    id: 'actions.buy-from',
    defaultMessage: 'Buy from {price}',
  },
  purchased: {
    id: 'actions.purchased',
    defaultMessage: 'You own this video',
  },
  rented: {
    id: 'actions.rented',
    defaultMessage: 'Rented until {date}',
  },
});



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/player/overlay-actions/translations.js